import {
  Home,
  Building2,
  Building,
  Mountain,
  Store,
  Tent,
  Hotel,
  HelpCircle,
} from "lucide-react";

interface PropertyTypeIconProps {
  className?: string;
}

const defaultClassName = "h-6 w-6";

export const HouseIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Home className={className} />
);

export const CondoIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Building2 className={className} />
);

export const TownhomeIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Building className={className} />
);

export const MultiUnitIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Building className={className} />
);

export const LandIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Mountain className={className} />
);

export const MobileHomeIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <div className="relative">
    <Home className={className} />
    <div className="absolute bottom-0 left-1/2 -translate-x-1/2">
      <div className="flex gap-0.5">
        <div className="h-1 w-1 rounded-full bg-current"></div>
        <div className="h-1 w-1 rounded-full bg-current"></div>
        <div className="h-1 w-1 rounded-full bg-current"></div>
      </div>
    </div>
  </div>
);

export const CommercialIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Store className={className} />
);

export const OtherPropertyIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <div className="relative">
    <Building className={className} />
    <div className="absolute -right-1 -top-1">
      <Home className="h-4 w-4" />
    </div>
  </div>
);

// Additional icons for Expired property types
export const ApartmentIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Building2 className={className} />
);

export const AcreageIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Mountain className={className} />
);

export const TwinIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Building className={className} />
);

export const RecreationalIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Tent className={className} />
);

export const MultiplexIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <Hotel className={className} />
);

export const UnknownPropertyIcon = ({ className = defaultClassName }: PropertyTypeIconProps) => (
  <HelpCircle className={className} />
);
